import script from "./CreatorDonutChart.vue?vue&type=script&setup=true&lang=js"
export * from "./CreatorDonutChart.vue?vue&type=script&setup=true&lang=js"

import "./CreatorDonutChart.vue?vue&type=style&index=0&id=a6e4762e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a6e4762e"]])

export default __exports__